module.exports = __webpack_public_path__ + "media/stylesheets/images/スクリーンショット 2022-07-03 15.25 1-cb4c6cb8701d8c360d34c00694798228.jpg";